<template>
    <FeaturesPageFeaturePanel icon="urleditor" :title="$t('pages.features.urlEditorCard.title')"
                              :desc="$t('pages.features.urlEditorCard.desc')">
        <ul class="urlEditorFeaturesList">
            <li v-for="(i,index) in $t('pages.features.urlEditorCard.featuresList')"
                :key="index">{{i}}
            </li>
        </ul>
        <div class="gallery-container">
            <UrlEditorScreenshotGallery/>
        </div>
    </FeaturesPageFeaturePanel>

</template>

<script>
    import FeaturesPageFeaturePanel from "./toolkit/FeaturesPageFeaturePanel";
    import UrlEditorScreenshotGallery from "./toolkit/UrlEditorScreenshotGallery"

    export default {
        name: "UrlEditorFeature",
        components: {FeaturesPageFeaturePanel,UrlEditorScreenshotGallery}
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    ul > li {
        font-size: 0.9em;
        margin-bottom: 0.5em;
        text-align:justify;
        margin-right: 1em;
    }
    .gallery-container {
        display: grid;
        justify-items: center;
        padding-right: 1rem;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
</style>